export const categories = [
  { slug: 'shuang-nanzhu', name: '下拉双男主', description: '精彩双男主韩漫推荐，热血与情感交织的故事', icon: 'ri-user-star-line' },
  { slug: 'mianfei-wuzhe', name: '免费无遮', description: '韩漫免费无遮漫画，畅享纯净阅读体验', icon: 'ri-eye-line' },
  { slug: 'aiqing-lianai', name: '爱情恋爱', description: '甜蜜浪漫的韩漫爱情故事合集', icon: 'ri-heart-line' },
  { slug: 'xuanhuan-kehuan', name: '玄幻科幻', description: '奇幻世界与未来科技的精彩碰撞', icon: 'ri-rocket-line' },
  { slug: 'xianshi-dushi', name: '现实都市', description: '贴近生活的都市韩漫作品', icon: 'ri-building-line' },
  { slug: 'xuanyi-zhiyu', name: '悬疑治愈', description: '悬疑烧脑与温暖治愈的韩漫精选', icon: 'ri-lightbulb-line' },
  { slug: 'guzhuang-wuxia', name: '古装武侠', description: '古风韩漫中的江湖恩怨与侠骨柔情', icon: 'ri-sword-line' },
  { slug: 'xiaoyuan-qingchun', name: '校园青春', description: '青春校园韩漫，回忆最美好的时光', icon: 'ri-book-open-line' },
];

export const getCategoryBySlug = (slug: string) => categories.find(c => c.slug === slug);